import { render, staticRenderFns } from "./PostalCodeInput.vue?vue&type=template&id=8f8fdf24&scoped=true&"
import script from "./PostalCodeInput.vue?vue&type=script&lang=js&"
export * from "./PostalCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeInput.vue?vue&type=style&index=0&id=8f8fdf24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8fdf24",
  null
  
)

export default component.exports